import { render, staticRenderFns } from "./AllTabsTransfer.vue?vue&type=template&id=b34ac564"
import script from "./AllTabsTransfer.vue?vue&type=script&lang=js"
export * from "./AllTabsTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports